import React, { FunctionComponent, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_one, fetch_all, fetch_all_with_count } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import EditIcon from '@mui/icons-material/Edit';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';

// import {
//   CircularProgress,
// } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  DataGrid,
  Dt,
  Fab,
  IconButton,
  Page,
  Typography,
} from '../../../components/v2/styled';

import { Bug } from '../../../models/Bug';
import { Practice } from '../../../models/Practice';
import { User } from '../../../models/User';
import { SearchBox } from '../../../components/v2/SearchBox';
import { Badge, Chip } from '@mui/material';
import Person from '@mui/icons-material/Person';
import PersonSearch from '@mui/icons-material/PersonSearch';
import ManageAccounts from '@mui/icons-material/ManageAccounts';
import Build from '@mui/icons-material/Build';

// const { DateTime } = require("luxon");

type Props = {}

export const AdminBugs: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  // const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [newBug, setNewBug] = useState<Bug>();

  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("status ASC, updated_at DESC, id DESC");
  const [search, setSearch] = useState<string>("");
  const [activeTag, setActiveTag] = useState<string>();
  const [activeStatus, setActiveStatus] = useState<string>();

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["admin", "bugs", {page: page, order: order, search: search, bug_type: activeTag, status: activeStatus}],
    queryFn: () =>
      fetch_all_with_count<Bug>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'bug',
          fields: [
            'id', 'title', 'status', 'created_at', 'content', 'bug_type', 'impact', 'internal_impact', 'get_item', 
            'item_file_name', 'practice_id', 'user_id', 'owner_id', 'ping_owner', 'ping_user', 'extra_data', 
            'practice|id/name', 'owner|id/full_name/email/type', 'extra_data', 'last_chat_time', 'last_chat_name'
          ],
          order: order,
          per_page: 20,
          page: page,
          filter: {
            search: search,
            advanced: {
              // practice_id: (login?.practice_id || currentPractice?.id),
              bug_type: activeTag,
              current_status: activeStatus
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: login?.type === "User::Admin",
  });














  const columns: GridColDef[] = [
    { field: 'id', headerName: '#', width: 80, renderCell: params => <>
      <Typography sx={{lineHeight: '48px'}}>{params.row.id}{(params.row.extra_data?.chat || []).length > 0 && <Badge color="primary" badgeContent={(params.row.extra_data?.chat || []).length}><NotificationImportantIcon color="primary" sx={{marginLeft: 1}} /></Badge>}</Typography>
    </> },
    { field: 'title', headerName: t("general.bugs.fields.title", "Onderwerp"), width: 200, renderCell: params => <>
      <Typography sx={{lineHeight: '50px', fontSize: '0.8rem'}}>{params.row.ping_owner && <NotificationImportantIcon color="primary" sx={{marginRight: 1, marginBottom: -1}} />}{params.row.title}</Typography>
    </> },
    { field: 'created_at', headerName: t("general.bugs.fields.created_at", "Aangemaakt"), width: 200, renderCell: params => <>
      <Dt d={params.row.created_at} f="DDD t" />
    </> },
    { field: 'last_chat_time', headerName: t("general.bugs.fields.last_chat_time", "Last chat"), width: 250, renderCell: params => <>
      {!!params.row.last_chat_time && <><Dt of="dd/LL/y TT" o={params.row.last_chat_time} f="DDD t" />/{params.row.last_chat_name}</>}
    </> },
    { field: 'bug_type', headerName: t("general.bugs.fields.sti", "STI"), width: 250, renderCell: params => <>
      {(params.row.status?.toString() || "-1") === '-1' && <Chip color="error" label="unhandled" sx={{marginRight: 1}} />}
      {(params.row.status?.toString() || "-1") === '0' && <Chip color="error" label="open" sx={{marginRight: 1}} />}
      {(params.row.status || 0) === 1 && <Chip color="warning" label="pending" sx={{marginRight: 1}} />}
      {(params.row.status || 0) === 2 && <Chip color="warning" label="waiting" sx={{marginRight: 1}} />}
      {(params.row.status || 0) === 3 && <Chip color="success" label="closed" sx={{marginRight: 1}} />}
      {(params.row.status || 0) === 4 && <Chip color="success" label="wishlist" sx={{marginRight: 1}} />}
      
      {(params.row.bug_type || 0) === 0 && <Chip color="error" label="bug" sx={{marginRight: 1}} />}
      {(params.row.bug_type || 0) === 1 && <Chip color="success" label="feature" sx={{marginRight: 1}} />}
      {(params.row.bug_type || 0) === 2 && <Chip color="info" label="question" sx={{marginRight: 1}} />}
      
      {params.row.bug_type === 0 && <>
        {params.row.impact === params.row.internal_impact && <>
          {(params.row.impact || 0) === 3 && <Chip color="error" label="breaking" sx={{marginRight: 1}} />}
          {(params.row.impact || 0) === 2 && <Chip color="warning" label="much" sx={{marginRight: 1}} />}
          {(params.row.impact || 0) === 1 && <Chip color="success" label="small" sx={{marginRight: 1}} />}
          {(params.row.impact || 0) === 0 && <Chip color="info" label="none" sx={{marginRight: 1}} />}
        </>}
        {params.row.impact !== params.row.internal_impact && <>
          {(params.row.internal_impact || 0) === 3 && <Chip icon={<Build />} color="error" label="breaking" sx={{marginRight: 1}} />}
          {(params.row.internal_impact || 0) === 2 && <Chip icon={<Build />} color="warning" label="much" sx={{marginRight: 1}} />}
          {(params.row.internal_impact || 0) === 1 && <Chip icon={<Build />} color="success" label="small" sx={{marginRight: 1}} />}
          {(params.row.internal_impact || 0) === 0 && <Chip icon={<Build />} color="info" label="none" sx={{marginRight: 1}} />}
        </>}
      </>}
    </> },
    { field: 'practice_name', headerName: t("general.bugs.fields.practice_name", "Praktijk"), width: 200 },
    { field: 'owner_full_name', headerName: t("general.bugs.fields.owner_full_name", "Eigenaar"), width: 200 },
    { field: 'owner_email', headerName: t("general.bugs.fields.owner_email", "Email"), width: 250 },
  ];

  return <Page title={t("admin.menu.tickets")}>
    <SearchBox
      search={search}
      setSearch={setSearch}
      objectCount={count}
      activeTag={activeTag}
      setActiveTag={setActiveTag}
      tags={[
        {id: '0', name: t("general.bugs.fields.bug_types.bug", "Bug")},
        {id: '1', name: t("general.bugs.fields.bug_types.feature", "Feature")},
        {id: '2', name: t("general.bugs.fields.bug_types.question", "Question")}
      ]}
      activeTag2={activeStatus}
      setActiveTag2={setActiveStatus}
      tags2={[
        {id: '0', name: t("general.bugs.fields.statusses.open", "Open")},
        {id: '1', name: t("general.bugs.fields.statusses.pending", "Pending")},
        {id: '2', name: t("general.bugs.fields.statusses.waiting", "Waiting")},
        {id: '3', name: t("general.bugs.fields.statusses.closed", "Closed")},
        {id: '4', name: t("general.bugs.fields.statusses.closed", "Wishlist")}
      ]}
    />
    <DataGrid
      action_count={2}
      hideCount
      actions={(params) => {
        return (<>
          <IconButton title="Edit" color="default" path={`/bug/${params.row.id}`}>
            <EditIcon />
          </IconButton>
          <IconButton title={
            params.row.owner_type === "User::User" ? "Client" : (
              params.row.owner_type === "User::Coach" ? "Coach": (
                params.row.owner_type === "User::Restricted" ? "Externe" : (
                  params.row.owner_type === "User::Admin" ? "Admin" : "Andere?"
                )
              )
            )
          } color="default" onClick={() => {
            window.open(`/user/${params.row.owner_id}/detail`, "_BLANk");
          }}>
            {params.row.owner_type === "User::User" && <Person/>}
            {params.row.owner_type === "User::Coach" && <SupervisorAccountIcon />}
            {params.row.owner_type === "User::Restricted" && <PersonSearch />}
            {params.row.owner_type === "User::Admin" && <ManageAccounts />}
          </IconButton>
        </>);
      }}
      objectCount={count}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(objects || []).map(u => ({
        ...u,
        enabled: (u.status || 0) < 3
      }))}
      columns={columns}
      loader={objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={page}
      setPage={(p) => {setPage(p);}}
    />

    <Fab
      onClick={() => {
        navigate("/bug/new");
      }}
    />
  </Page>;
}
